
import { FormElementController, FormPageValidator, FormElementValidator, StringValidators, IValidatingObject, ValidationResult, FormElementStatus } from './../../../scripts/formcontrols'
import { DrugDto } from "./../../../dto/DrugDto"
import Dal from './../../../scripts/dataaccess';
import { WardCycleDto, PatientOrderItemDto, DispensationItemDto, MedRoundDto } from './../../../dto/Dtos';
import { PatientDto } from './../../../dto/PatientDto';
import RoundSelectorController from '../RoundSelector/RoundSelectorController';
import { WardDto } from '../../../dto/WardDto';
import moment from 'moment';
import $ from 'jquery'
import Formatter from "../../corecontrols/formatters/Formatter";
import { noop } from 'vue-class-component/lib/util';

export default class DispensationItemController extends FormPageValidator {

    private patient: PatientDto;
    private cycle: WardCycleDto;
    private ward: WardDto;
    private dispensationItem: DispensationItemDto;
    private virtualItemStarted: boolean = false;
    private virtualItemRemoved: boolean = false;
    
    public IsNew: boolean;
    
    private IsUpdating: boolean = false;

    public get HasChanged(): boolean {
        return this.HasDatesChanged || this.HasDosageChanged || this.HasDetailsChanged || this.HasVirtualItemStarted || this.HasVirtualItemRemoved;
    }

    public get HasVirtualItemStarted(): boolean {
        return this.virtualItemStarted && this.dispensationItem.createdFromPatientOrder;
    }
    public get HasVirtualItemRemoved(): boolean {
        return this.virtualItemRemoved && this.dispensationItem.createdFromPatientOrder;
    }
    

    public get HasEndDateChanged(): boolean {
        return moment(this.dispensationItem.endDate).diff(moment(this.endDate.value), 'days') != 0;
    }
    public get HasDatesChanged(): boolean {
        return moment(this.dispensationItem.endDate).diff(moment(this.endDate.value), 'days') != 0 ||
            moment(this.dispensationItem.startDate).diff(moment(this.startDate.value), 'days') != 0;
    }

    public get HasDetailsChanged(): boolean {
        var result = 
        this.notes.value != this.dispensationItem.notes
        || this.quantity.value != this.dispensationItem.quantity
        || this.IsNull(this.unitOfMeasure.value,"") != this.IsNull(this.dispensationItem.unitOfMeasure, "")
        || this.isInsulin.value != this.dispensationItem.isInsulin
        || this.showInEMAR.value != this.dispensationItem.showInEMAR
        || this.treatAsCD.value != this.dispensationItem.treatAsCD
        || this.useBodyMap.value != this.dispensationItem.useBodyMap;
        return result;
    }

    private IsNull<T>(a : T, b : T) : T{
        if (!a)
            return b;
        else
            return a;
    }


    // Checks Changes in Dosage PAttern, Dosage Instruction & Rounds
    public get HasDosageChanged(): boolean {
        if (this.dispensationItem.daysOfDosagePattern != this.daysOfDosage.value) {
            return true;
        }

        if (this.dispensationItem.dosageInstruction != this.dosageInstruction.value) {
            return true;
        }

        var currentRounds = this.dispensationItem.medRounds.filter(r => r.dosage && r.dosage.trim().replace("0", "").length > 0).sort((a, b) => moment(b.roundTime, 'HH:mm').toDate().getTime() - moment(a.roundTime, 'HH:mm').toDate().getTime());
        var newRounds = this.roundsController.Value.filter(r => r.dosage && r.dosage.trim().replace("0", "").length > 0).sort((a, b) => moment(b.roundTime).toDate().getTime() - moment(a.roundTime).toDate().getTime());

        if (currentRounds.length != newRounds.length) {
            //console.log("Rounds length changed !", currentRounds, newRounds)
            return true;
        }

        var index = 0;
        //console.log("running dosage comparison ", currentRounds, newRounds)
        for (var cr of currentRounds) {
            var uiRound = newRounds.find(r => moment(cr.roundTime, "HH:mm:ss").format("HH:mm") == moment(r.roundTime, "HH:mm").format("HH:mm"))
            if (!uiRound) {
                //console.log("failed", moment(cr.roundTime, "HH:mm:ss").format("HH:mm") )
                return true;
            }

            if (Formatter.HexColour(cr.colourHex) != Formatter.HexColour(uiRound.colourHex)) {
                //console.log("Colour changed !" + this.drug.value.searchText + index.toString(), Formatter.HexColour(cr.colourHex), Formatter.HexColour(uiRound.colourHex), cr, uiRound )
                return true;
            }
            if (cr.displayTextRound != uiRound .displayTextRound) {
                //console.log("Display Tetx changed !" + this.drug.value.searchText + index, cr, uiRound )
                return true;
            }
            if (cr.dosage != uiRound .dosage) {
                //console.log("Dosage changed !" + this.drug.value.searchText + index, cr, uiRound )
                return true;
            }

            //if (moment(cr.roundTime, "HH:mm").format("HH:mm") != moment(uiRound .roundTime).format("HH:mm")) {
            if (moment(cr.roundTime, "HH:mm").format("HH:mm") != moment(uiRound .roundTime, "HH:mm").format("HH:mm")) {
                //console.log("Round Time changed !" + moment(cr.roundTime, "HH:mm").format("HH:mm") + ":" + uiRound.roundTime + moment(uiRound.roundTime, "HH:mm").format("HH:mm"))
                return true;
            }

            index++;
        }

        return false;
    }


    public get IsCycleActive() {
        var today = moment(new Date()).startOf('day');
        var start = moment(this.cycle.startDate).startOf('day')
        var end = moment(this.cycle.endDate).startOf('day')

        console.log("today : ", today, end, start)
        console.log("today : ", today.isBetween(start, end) || today.isSame(start) || today.isSame(end));

        return today.isBetween(start, end) || today.isSame(start) || today.isSame(end);
    }

    public get IsPharmacyDispensed() {
        return this.dispensationItem.pharmacyDispensed;
    }

    public get IsVirtual() {
        return this.dispensationItem.createdFromPatientOrder;
    }

    public get Original(): DispensationItemDto {
        return this.dispensationItem;
    }

    drug: FormElementController<DrugDto>;
    startDate: FormElementController<Date>;
    newDosageStartDate: FormElementController<Date>;
    endDate: FormElementController<Date>;

    isInsulin: FormElementController<boolean>;
    showInEMAR: FormElementController<boolean>;
    treatAsCD: FormElementController<boolean>;
    useBodyMap: FormElementController<boolean>;

    daysOfDosage: FormElementController<string>;
    roundsController: RoundSelectorController;

    // Text Field
    dosageInstruction: FormElementController<string>;
    notes: FormElementController<string>;
    quantity: FormElementController<number>;
    unitOfMeasure: FormElementController<string>;


    constructor(cycle: WardCycleDto, patient: PatientDto, ward: WardDto, dispensationItem: DispensationItemDto | any = undefined) {
        super("DispensationItemController");
        //console.log("MedProfileEditorController Constructor ", cycle, patient, ward, ward.wardRounds)
        this.cycle = cycle;
        this.patient = patient;
        this.ward = ward;

        this.IsUpdating = false;
        if (dispensationItem) {
            this.IsNew = false;
            this.dispensationItem = dispensationItem;
        }
        else {
            this.IsNew = true;
            this.dispensationItem = new DispensationItemDto();
            this.dispensationItem.endDate = moment(cycle.endDate).startOf('day').toDate();
            this.dispensationItem.startDate = moment(new Date()).startOf('day').toDate();
            this.dispensationItem.daysOfDosagePattern = "1";
            this.dispensationItem.medRounds = [];
        }

        var item = this.dispensationItem;

        var drugValidator       = new FormElementValidator(true);
        var quantityValidator = new FormElementValidator(true, (v) => !v || v < 0 ? new ValidationResult(FormElementStatus.Error, "Enter a correct quantity") : new ValidationResult(FormElementStatus.Success, ""));
        var statusValidator = new FormElementValidator(true);
        var startDateValidator = new FormElementValidator(true);
        var endDateValidator = new FormElementValidator(true);
        var dosageValidator = new FormElementValidator(true, (d) => d == "0" ? new ValidationResult(FormElementStatus.Error, "Atleast one day should have dosage") : new ValidationResult(FormElementStatus.Success, ""));

        //ward.wardRounds.forEach(r => { if (!r.colourHex) r.colourHex = r.colourHex });
        this.roundsController = new RoundSelectorController(ward.wardRounds, item.medRounds ? item.medRounds : []);
        this.daysOfDosage = new FormElementController<string>("Dosage", item.daysOfDosagePattern, dosageValidator);

        var drug = new DrugDto();
        drug.apid = item.apid;
        drug.vpid = item.vpid;
        drug.searchText = item.drugName;

        this.drug = new FormElementController<DrugDto>("Drug", drug, drugValidator);
        this.startDate = new FormElementController<Date>("StartDate", item.startDate, startDateValidator);
        this.newDosageStartDate = new FormElementController<Date>("StartDate", new Date(), startDateValidator);
        this.endDate = new FormElementController<Date>("EndDate", item.endDate, endDateValidator);
        this.quantity = new FormElementController<number>("Quantity", item.quantity, quantityValidator);
        this.unitOfMeasure = new FormElementController<string>("Unit of Measure", item.unitOfMeasure);

        this.isInsulin = new FormElementController<boolean>("Is Insulin", item.isInsulin);
        this.showInEMAR = new FormElementController<boolean>("ShowInEMAR", item.showInEMAR);
        this.treatAsCD = new FormElementController<boolean>("Treat As CD", item.treatAsCD);
        this.useBodyMap = new FormElementController<boolean>("Use Body Map", item.useBodyMap);

        this.dosageInstruction = new FormElementController<string>("Dosage Instruction", item.dosageInstruction);
        this.notes = new FormElementController<string>("Notes", item.notes);

        this.addValidators(
            drugValidator      ,
            quantityValidator  ,
            statusValidator,
            startDateValidator,
            endDateValidator, dosageValidator
            , this.roundsController)

        this.roundsController.validate();
    }

    public StartVirtualItem() {
        this.startDate.value = moment(new Date()).toDate();
        this.virtualItemStarted = true;
    }
    public RemoveVirtualItem() {
        this.virtualItemRemoved = true;
    }

    public StopActiveItem() {
        this.endDate.value = moment(new Date()).toDate();
    }

    public Reset() {
        this.ResetDosage();
        this.ResetUpdates();
        this.virtualItemStarted = false;
        this.virtualItemRemoved = false;
    }

    public ResetDosage() {
        this.removeValidator(this.roundsController)
        this.roundsController = new RoundSelectorController(this.ward.wardRounds, this.dispensationItem.medRounds ? this.dispensationItem.medRounds : []);
        this.addValidator(this.roundsController);

        this.daysOfDosage.value = this.dispensationItem.daysOfDosagePattern;
        this.dosageInstruction.value = this.dispensationItem.dosageInstruction;

        //console.log("Errors after reset " + this.roundsController.hasError, this.daysOfDosage.hasError, this.dosageInstruction.hasError);
    }


    public ResetUpdates() {

        this.endDate.value = this.dispensationItem.endDate;

        this.quantity.value = this.dispensationItem.quantity;
        this.unitOfMeasure.value = this.dispensationItem.unitOfMeasure;
        this.notes.value = this.dispensationItem.notes;

        this.isInsulin.value  = this.dispensationItem.isInsulin;
        this.showInEMAR.value =  this.dispensationItem.showInEMAR;
        this.treatAsCD.value  =  this.dispensationItem.treatAsCD;
        this.useBodyMap.value = this.dispensationItem.useBodyMap;

    }

    public GetItem(): DispensationItemDto {
        var item = $.extend(true, {}, this.dispensationItem);


        item.startDate = moment(this.startDate.value).startOf('day').toDate();
        item.endDate = moment(this.endDate.value).startOf('day').toDate();
        item.dosageInstruction = this.dosageInstruction.value;
        item.medRounds = this.roundsController.Rounds.map(r => r.GetItem()).filter(r => r.dosage.replace('0', '').length > 0)
        item.daysOfDosagePattern = this.daysOfDosage.value;

        item.quantity = this.quantity.value;
        item.unitOfMeasure = this.unitOfMeasure.value;
        item.notes = this.notes.value;

        item.isInsulin = this.isInsulin.value;
        item.showInEMAR = this.showInEMAR.value;
        item.treatAsCD = this.treatAsCD.value;
        item.useBodyMap = this.useBodyMap.value;


        if (this.IsNew) {
            item.apid = this.drug.value.apid;
            item.vpid = this.drug.value.vpid;
            item.drugName = this.drug.value.searchText;
        }


        if (this.HasDosageChanged) {
            item.dosageChanged = true;
        }
        return item;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/PatientMedProfile2/DispensationItemController.ts